/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateUpdatePriceDto } from './CreateUpdatePriceDto';
import {
    CreateUpdatePriceDtoFromJSON,
    CreateUpdatePriceDtoFromJSONTyped,
    CreateUpdatePriceDtoToJSON,
} from './CreateUpdatePriceDto';

/**
 * 
 * @export
 * @interface CreateUpdatePricingDto
 */
export interface CreateUpdatePricingDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdatePricingDto
     */
    name?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdatePricingDto
     */
    startDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdatePricingDto
     */
    endDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdatePricingDto
     */
    companyId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdatePricingDto
     */
    percentageDiscount?: string | null;
    /**
     * 
     * @type {Array<CreateUpdatePriceDto>}
     * @memberof CreateUpdatePricingDto
     */
    prices?: Array<CreateUpdatePriceDto> | null;
}

/**
 * Check if a given object implements the CreateUpdatePricingDto interface.
 */
export function instanceOfCreateUpdatePricingDto(value: object): value is CreateUpdatePricingDto {
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    return true;
}

export function CreateUpdatePricingDtoFromJSON(json: any): CreateUpdatePricingDto {
    return CreateUpdatePricingDtoFromJSONTyped(json, false);
}

export function CreateUpdatePricingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdatePricingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'startDate': (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'companyId': json['companyId'] == null ? undefined : json['companyId'],
        'percentageDiscount': json['percentageDiscount'] == null ? undefined : json['percentageDiscount'],
        'prices': json['prices'] == null ? undefined : ((json['prices'] as Array<any>).map(CreateUpdatePriceDtoFromJSON)),
    };
}

export function CreateUpdatePricingDtoToJSON(value?: CreateUpdatePricingDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'startDate': ((value['startDate']).toISOString()),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate'] as any).toISOString()),
        'companyId': value['companyId'],
        'percentageDiscount': value['percentageDiscount'],
        'prices': value['prices'] == null ? undefined : ((value['prices'] as Array<any>).map(CreateUpdatePriceDtoToJSON)),
    };
}

